import { store } from "../lib/store.js";
import { supabase } from "../lib/supabase.js";
import { formatCurrency, formatHours, formatPercent } from "../utils/format.js";
import { signOut } from "../lib/auth.js";

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text ?? "";
  return div.innerHTML;
}

async function fetchMetrics() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) return;

  try {
    const response = await fetch("/api/metrics", {
      headers: { Authorization: `Bearer ${session.access_token}` },
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const metrics = await response.json();
    store.metrics.set(metrics);
  } catch (error) {
    console.error("Falha ao buscar métricas do HUD", error);
  }
}

export function mountHud(root) {
  root.innerHTML = `
    <header class="hud" role="banner">
      <div class="hud-metrics" aria-label="Métricas globais">
        <span class="hud-metric hud-metric--orders" data-metric="orders">🎨 —</span>
        <span class="hud-metric hud-metric--revenue" data-metric="revenue">💰 —</span>
        <span class="hud-metric hud-metric--time hud-metric--secondary" data-metric="time">⏱️ —</span>
        <span class="hud-metric hud-metric--approval hud-metric--secondary" data-metric="approval">✅ —</span>
      </div>
      <div class="hud-actions">
        <div class="hud-bell-wrapper">
          <button class="hud-bell" aria-label="Notificações" aria-haspopup="true" aria-expanded="false">
            🔔<span class="hud-bell-badge" hidden></span>
          </button>
          <div class="hud-notifications-drawer" hidden role="menu" aria-label="Alertas do sistema"></div>
        </div>
        <button class="hud-signout" aria-label="Sair">Sair</button>
      </div>
    </header>
  `;

  const orderEl = root.querySelector('[data-metric="orders"]');
  const revenueEl = root.querySelector('[data-metric="revenue"]');
  const timeEl = root.querySelector('[data-metric="time"]');
  const approvalEl = root.querySelector('[data-metric="approval"]');
  const bellButton = root.querySelector(".hud-bell");
  const bellBadge = root.querySelector(".hud-bell-badge");
  const notificationsDrawer = root.querySelector(".hud-notifications-drawer");

  const unsubscribeMetrics = store.metrics.subscribe((metrics) => {
    if (!metrics) return;
    orderEl.textContent = `🎨 ${metrics.ordersToday} pedidos hoje`;
    revenueEl.textContent = `💰 ${formatCurrency(metrics.revenueToday)}`;
    timeEl.textContent = `⏱️ ${formatHours(metrics.avgProductionHours)}`;
    approvalEl.textContent = `✅ ${formatPercent(metrics.approvalRate)}`;
  });

  const unsubscribeAlerts = store.systemAlerts.subscribe((alerts) => {
    const unresolved = alerts.length;
    bellBadge.hidden = unresolved === 0;
    bellBadge.textContent = String(unresolved);
    notificationsDrawer.innerHTML = unresolved
      ? alerts
          .map(
            (alert) => `
            <div class="hud-notification hud-notification--${alert.severity}" role="menuitem">
              <strong>${escapeHtml(alert.component)}</strong>
              <span>${escapeHtml(alert.message)}</span>
            </div>
          `,
          )
          .join("")
      : `<p class="hud-notifications-empty">Nenhum alerta ativo.</p>`;
  });

  bellButton.addEventListener("click", () => {
    const isOpen = !notificationsDrawer.hidden;
    notificationsDrawer.hidden = isOpen;
    bellButton.setAttribute("aria-expanded", String(!isOpen));
  });

  root.querySelector(".hud-signout").addEventListener("click", () => signOut());

  fetchMetrics();
  const intervalId = setInterval(fetchMetrics, 60_000);

  return () => {
    unsubscribeMetrics();
    unsubscribeAlerts();
    clearInterval(intervalId);
    root.innerHTML = "";
  };
}
